import React from 'react';
import { string, shape } from 'prop-types';

export default function ResourceTile({ item }) {
    // eslint-disable-next-line
    const getSummary = obj => <div className="summary" dangerouslySetInnerHTML={{ __html: obj.excerpt }} />;

    return (
        <div className="c-tile c-opshop-tile c-content-tile tile-bg-1 resource-tile">
            <div className="tile-content">
                <p className="location">{item.date}</p>
                <div className="flex-container">
                    <div className="text">
                        <h3 className="display">{item.title}</h3>
                        {getSummary(item)}
                        <div>
                            <a href={item.url} className="btn btn-skin-3 btn-small">More details</a>
                        </div>
                    </div>
                    <img src={item.thumbnail} alt="" />
                </div>
            </div>
        </div>
    );
}

ResourceTile.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        date: string.isRequired,
        title: string.isRequired,
        excerpt: string.isRequired,
        url: string.isRequired,
        thumbnail: string.isRequired
    }).isRequired
    /* eslint-enable react/no-typos */
};



// WEBPACK FOOTER //
// ./src/components/tiles/ResourceTile.jsx